import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';

import { ENTITIES_KEY_FONT } from 'common/entities/font';
import { ENTITIES_KEY_COLOR } from 'common/entities/color';
import { ENTITIES_KEY_FORM } from 'common/entities/form';
import { ENTITIES_KEY_NODE } from 'common/entities/formNode';
import { ENTITIES_KEY_FORM_LOGIC_RULE } from 'common/entities/formLogicRule';
import { ENTITIES_KEY_TICKET_TYPES } from 'common/entities/ticketType';

import {
    SET_FORM_ID,
    SET_UPLOAD_URL,
    SET_SUBMIT_URL,
    SET_EVENT_ID,
    SET_FORM_INITIAL_STATE,
    SET_FORM_IS_UPDATING,
    SET_VIEWER_DATA,
    SET_GUEST_ACCESS_HASH,
    SET_FORM_IS_MOBILE_RSVP,
    SET_LIMIT_ONE_ORDER_PER_EMAIL,
    SET_LIMIT_ONE_TICKET_TYPE_PER_EMAIL,
    SET_IS_ATTENDING,
    SET_IS_REGISTRATION_OPEN,
    SET_SESSIONS_STEP,
    SET_FORM_SESSIONS,
} from '../constants/actionTypes';

import formReducer from './form';

const initialState = {
    id: null,
    uploadUrl: null,
    isUpdating: false,
    isMobileRsvp: false,
    limitOneOrderPerEmail: false,
    limitOneTicketTypePerEmail: false,
    isAttending: false,
    isRegistrationOpen: true,
};

const handlers = {
    [SET_FORM_ID]: (state, { payload }) => ({
        ...state,
        id: payload,
    }),
    [SET_UPLOAD_URL]: (state, { payload }) => ({
        ...state,
        uploadUrl: payload,
    }),
    [SET_SUBMIT_URL]: (state, { payload }) => ({
        ...state,
        submitUrl: payload,
    }),
    [SET_EVENT_ID]: (state, { payload }) => ({
        ...state,
        eventId: payload,
    }),
    [SET_FORM_IS_UPDATING]: (state, { payload }) => ({
        ...state,
        isUpdating: payload,
    }),
    [SET_FORM_INITIAL_STATE]: (state, { payload }) => ({
        ...state,
        formInitialState: payload,
    }),
    [SET_VIEWER_DATA]: (state, { payload }) => ({
        ...state,
        viewerData: payload,
    }),
    [SET_GUEST_ACCESS_HASH]: (state, { payload }) => ({
        ...state,
        guestAccessHash: payload,
    }),
    [SET_FORM_IS_MOBILE_RSVP]: (state, { payload }) => ({
        ...state,
        isMobileRsvp: payload,
    }),
    [SET_LIMIT_ONE_ORDER_PER_EMAIL]: (state, { payload }) => ({
        ...state,
        limitOneOrderPerEmail: payload,
    }),

    [SET_LIMIT_ONE_TICKET_TYPE_PER_EMAIL]: (state, { payload }) => ({
        ...state,
        limitOneTicketTypePerEmail: payload,
    }),

    [SET_IS_ATTENDING]: (state) => ({
        ...state,
        isAttending: true,
    }),
    [SET_IS_REGISTRATION_OPEN]: (state, { payload }) => ({
        ...state,
        isRegistrationOpen: payload,
    }),
    [SET_SESSIONS_STEP]: (state, action) => ({
        ...state,
        sessionsStep: action.payload,
    }),
    [SET_FORM_SESSIONS]: (state, { payload }) => ({
        ...state,
        sessionIds: payload?.result,
    }),
};

export const initialEntities = {
    [ENTITIES_KEY_FONT]: {},
    [ENTITIES_KEY_COLOR]: {},
    [ENTITIES_KEY_FORM]: {},
    [ENTITIES_KEY_NODE]: {},
    [ENTITIES_KEY_FORM_LOGIC_RULE]: {},
    [ENTITIES_KEY_TICKET_TYPES]: {},
};

export const mainReducers = createReducer(initialState, handlers);

export default combineReducers({
    app: mainReducers,
    form: formReducer,
});
